export enum BuilderSidebarPanel {
    Elements = 'elements',
    Inspector = 'inspector',
    Pages = 'pages',
    Themes = 'themes',
    Layout = 'layout',
}
